var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Stack, TextField, Typography, useTheme, } from '@mui/material';
import { debounce } from 'lodash';
import { fetchAudiences } from '../../../api';
import { useEffect, useMemo, useState } from 'react';
import { useStudyContext } from '../../../context';
const placeholderText = 'e.g. Eco Conscious Consumers, Travel Enthusiasts...';
export const AudienceAutocomplete = () => {
    var _a;
    const theme = useTheme();
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { studyPayload, updateAudiencesPayload, canCreateStudy } = useStudyContext();
    const debouncedFetchAudiences = useMemo(() => debounce((value) => __awaiter(void 0, void 0, void 0, function* () {
        handleFetchAudiences(value);
    }), 400), []);
    const handleSelectChange = (e, newValues) => {
        updateAudiencesPayload(newValues);
    };
    const handleInputChange = (e, value) => {
        setOptions([]);
        setLoading(true);
        debouncedFetchAudiences(value);
        setInputValue(value);
        if (error.length > 0)
            setError('');
    };
    const handleFetchAudiences = (value) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setError('');
            const response = yield fetchAudiences(value);
            setOptions(response.data);
        }
        catch (error) {
            console.error('Failed to fetch audiences:', error);
            setError('Failed to fetch audiences');
        }
        finally {
            setLoading(false);
        }
    });
    useEffect(() => {
        handleFetchAudiences(inputValue);
    }, []);
    return (_jsxs(Stack, { gap: "8px", flex: 2, children: [_jsx(Typography, { fontSize: "12px", fontWeight: 700, letterSpacing: "0.17px", color: theme.palette.secondary.dark, children: "Audience (Optional):" }), _jsx(Autocomplete, { disabled: !canCreateStudy, multiple: true, size: "small", options: options, loading: isLoading, value: (_a = studyPayload === null || studyPayload === void 0 ? void 0 : studyPayload.audiences) !== null && _a !== void 0 ? _a : [], onChange: handleSelectChange, inputValue: inputValue, onInputChange: handleInputChange, renderInput: params => {
                    var _a;
                    return (_jsx(TextField, Object.assign({}, params, { size: "small", variant: "standard", helperText: error, error: error.length > 0, placeholder: !((_a = studyPayload === null || studyPayload === void 0 ? void 0 : studyPayload.audiences) === null || _a === void 0 ? void 0 : _a.length) ? placeholderText : '', slotProps: {
                            input: Object.assign(Object.assign({}, params.InputProps), { disableUnderline: true }),
                        } })));
                }, sx: {
                    '& .MuiChip-root': {
                        margin: '0px',
                        height: '24px',
                        borderRadius: '16px',
                        backgroundColor: theme.palette.background.default,
                        border: `1px solid ${theme.palette.grey[400]}`,
                    },
                    '& .MuiChip-label ': {
                        fontSize: '13px',
                        fontWeight: 400,
                        color: theme.palette.secondary.dark,
                    },
                    '& .MuiChip-deleteIcon': {
                        height: '17px',
                        width: '17px',
                    },
                    '& .MuiInputBase-root': {
                        gap: '4px',
                    },
                } })] }));
};
